// extracted by mini-css-extract-plugin
module.exports = {"gridPhoto":"style_gridPhoto__Mn7CN","image":"style_image__X_wlm","gridContent":"style_gridContent__dsU4X","breathAnimation":"style_breathAnimation__ChMia"};